import {login, loginByPhone} from 'api/login/login';

const user = {
  state: {
    username: '',
    userInfo: null,
    sessionId: localStorage.getItem('sessionId'),
    userName: localStorage.getItem('username'),
  },

  mutations: {
    SET_NAME: (state, name) => {
      state.username = name;
    },
    SET_USERINFO: (state, data) => {
      state.userInfo = data;
    },
    SET_USERID: (state, data) => {
      state.sessionId = data;
    },
    SET_USERNAME: (state, data) => {
      state.userName = data;
    },
  },
  actions: {
    login({commit}, data) {
      return new Promise((resolve, reject) => {
        login(data).then(res => {
          if (res.type === 'success') {
            console.log(res.data)
            localStorage.setItem('sessionId', res.data.sessionId);
            localStorage.setItem('username', res.data.userName);
            localStorage.setItem('account', res.data.account);
            localStorage.setItem('userType', res.data.userType);
            commit('SET_NAME', res.data.userName);
            commit('SET_USERINFO', res.data);
            commit('SET_USERID', res.data.sessionId);
            commit('SET_USERNAME', res.data.userName);
            setTimeout(function () {
              resolve();
            }, 5)
          } else {
            reject(res);
          }
        })
      });
    },
    loginByPhone({commit}, data) {
      return new Promise((resolve, reject) => {
        loginByPhone(data).then(res => {
          if (res.type === 'success') {
            console.log(res.data)
            localStorage.setItem('sessionId', res.data.sessionId);
            localStorage.setItem('username', res.data.userName);
            localStorage.setItem('userAccount', res.data.userAccount);
            localStorage.setItem('userType', res.data.userType);
            commit('SET_NAME', res.data.userName);
            commit('SET_USERINFO', res.data);
            setTimeout(function () {
              resolve();
            }, 5)
          } else {
            reject(res);
          }
        })
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js